<!-- 公共轮播图 -->
<template>
    <div>
        <el-carousel trigger="click" :height="swiperHeight+ 'px'">
            <el-carousel-item v-for="item in 4" :key="item">
                <img src="../assets/imgs/school.jpg" alt="" class="school_item" ref="schoolImg">
            </el-carousel-item>
        </el-carousel>

    </div>
</template>

<script>
export default {
    data() {
        return {
            swiperHeight: 300,
        };
    },

    mounted() {

        this.$nextTick(() => {
            setTimeout(() => {
                if (this.$refs.schoolImg[0]) {
                    this.swiperHeight = this.$refs.schoolImg[0].clientHeight
                }
            },1000)
        })

        window.addEventListener(
            'resize',
            () => {
                if (this.$refs.schoolImg[0]) {
                    this.swiperHeight = this.$refs.schoolImg[0].clientHeight
                }
            },
            false
        )

    },

    methods: {}
}

</script>
<style lang='less' scoped>
.school_item {
    width: 100%;
    // height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ComSwiper.vue